import {
  SET_DROPDOWN_PRODUCTS,
  SET_DROPDOWN_OPERATORS,
  SET_DROPDOWN_AREAS,
  SET_DROPDOWN_DEVICES,
  SET_DROPDOWN_LOCATIONS,
  SET_DROPDOWN_ORDER_STATUSES,
  SET_DROPDOWN_TRANSACTION_STATUSES,
} from "../constants/action-types";

const initialState = {
  productsData: [],
  operatorsData: [],
  areasData: [],
  devicesData: [],
  locationsData: [],
  orderStatusData: [],
  transactionStatusData: [],
  inventoryData: [],
};

const dropdownReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DROPDOWN_PRODUCTS:
      return { ...state, productsData: action.payload };
    case SET_DROPDOWN_OPERATORS:
      return { ...state, operatorsData: action.payload };
    case SET_DROPDOWN_AREAS:
      return { ...state, areasData: action.payload };
    case SET_DROPDOWN_DEVICES:
      return { ...state, devicesData: action.payload };
    case SET_DROPDOWN_LOCATIONS:
      return { ...state, locationsData: action.payload };
    case SET_DROPDOWN_ORDER_STATUSES:
      return { ...state, orderStatusData: action.payload };
    case SET_DROPDOWN_TRANSACTION_STATUSES:
      return { ...state, transactionStatusData: action.payload };
    default:
      return state;
  }
};

export default dropdownReducer;
